import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { EnvelopeSimple, Clock, Question } from '@phosphor-icons/react';
import { SITE } from '@/content/site';

const contactInfo = [
  { icon: EnvelopeSimple, label: 'Email', value: SITE.email, href: `mailto:${SITE.email}` },
  { icon: Clock, label: 'Response time', value: 'Within 2–3 business days' },
  { icon: Question, label: 'Quick answers', value: 'Browse the FAQ', to: '/faq' },
];

const Value = ({ info }) => {
  const cls = 'text-[#09090B] font-medium hover:text-[#0047FF] transition-colors break-all';
  if (info.href) return <a href={info.href} className={cls} data-testid="landing-contact-email">{info.value}</a>;
  if (info.to) return <Link to={info.to} className={cls}>{info.value}</Link>;
  return <p className="text-[#09090B] font-medium">{info.value}</p>;
};

export const ContactSection = () => (
  <section id="contact" className="py-24 px-6 bg-white" data-testid="landing-contact-section">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#09090B] mb-6">Contact Us</h2>
        <p className="text-lg text-[#71717A] mb-8">
          Questions, feedback or a player to report? Email us and a real person will get back to you.
        </p>
        <Button asChild className="bg-[#0047FF] hover:bg-[#0037CC] text-white" data-testid="landing-contact-page-link">
          <Link to="/contact">All contact options</Link>
        </Button>
      </div>
      <div className="bg-[#FAFAFA] p-8 border border-[#E4E4E7] space-y-6">
        {contactInfo.map((info) => {
          const Icon = info.icon;
          return (
            <div key={info.label} className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white border border-[#E4E4E7] flex items-center justify-center shrink-0">
                <Icon size={24} className="text-[#0047FF]" />
              </div>
              <div>
                <p className="text-sm text-[#71717A]">{info.label}</p>
                <Value info={info} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
